// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"611":"db8f59414559c9e1","745":"19f5782df289b400","880":"1e9c26bbddaa914e"}[chunkId] + ".js";
};